import React from 'react';
import { Route, Routes, BrowserRouter } from 'react-router-dom';
import Home from './components/sections/Home/home';
import About from './components/sections/About/about';
import Projects from './components/sections/Projects/projects';
import Support from './components/sections/Support/support';
import './index.css';

function App() {
  return (
    <div>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/projects" element={<Projects />} />
          <Route path="/support" element={<Support />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
